import { CobrancaTipo } from './cobranca-tipo.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class CobrancaTipoService {

    constructor(private http: Http) {
    }

    getCobrancaTipos(): Observable<CobrancaTipo[]> {
        return this.http.get(`${NTECH_API}/cobranca-tipo`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/cobranca-tipo/cobranca-tipo.service.ts